import React, { createContext, useContext } from 'react'
import { useRouteMatch, useLocation } from '@fs/zion-router'
import { useQuery } from '@apollo/client'
import api from '../api/brightspot'

export const groupType = 'VENDOR'
export const companiesExcludedInChat = ['Ancestry']

export const VendorContext = createContext()

export const useCurrentVendor = () => useContext(VendorContext)

export function VendorProvider({ children }) {
  const routeMatch = useRouteMatch('/expohall/:sponsorId')
  const { search } = useLocation()
  const params = new URLSearchParams(search)
  const sponsorId = params.get('sponsorId')

  const pathOrId = sponsorId || `/expohall/${routeMatch?.params.sponsorId}`
  const query = useQuery(api.virtualBooth.virtualBoothGQLQuery(pathOrId), {
    // Don't request the data if we don't have a sponsor id
    skip: !sponsorId && !routeMatch?.params.sponsorId,
  })

  return <VendorContext.Provider value={query}>{children}</VendorContext.Provider>
}
